module.exports = __webpack_public_path__ + "static/media/heart.ca687946.svg";